import React from "react";
import { useSelector } from "react-redux";
import { Box, Flex, Image, Text } from "rebass";
import { FaExclamationTriangle } from "react-icons/fa";
import get from "lodash/get";

import { SpinnerSVG } from "../svg/SpinnerSVG";

import { getModalProps } from "../../../store/modules/modal/selectors";
import { useBlob, ResultType } from "../../hooks/useBlob";

export const ShowFile: React.FC = () => {
  const modalProps = useSelector(getModalProps);
  const file: File | undefined = get(modalProps, "file");
  const fileURL = useBlob(file, ResultType.DATA_URL);

  return (
    <Flex
      height="100%"
      alignItems="center"
      justifyContent="center"
      css="min-width: 20rem; max-width: 60rem; min-height: 20rem; max-height: 90vh; overflow: hidden; transition: .3s all;"
    >
      {(() => {
        switch (fileURL) {
          case undefined: // file is processing
            return (
              <Box color="sp-blue">
                <SpinnerSVG size={30} />
              </Box>
            );
          case "error": // file source is not exist
            return (
              <Box color="rgba(255,0,0,.5)">
                <Text fontSize="40px" textAlign="center">
                  <FaExclamationTriangle />
                </Text>

                <Text fontSize="16px">
                  File is corrupted
                </Text>
              </Box>
            );
          default: // show anyway
            return <Image src={fileURL} alt="preview" />;
        }
      })()}
    </Flex>
  );
}
